export class DoubleCheck {

  total: number;
  confirmed: number;
  missing: number;

  constructor(o: any) {
    this.total = o.total || 0;
    this.confirmed = o.confirmed || 0;
    this.missing = o.missing || 0;
  }

  get unconfirmed(): number {
    return this.total - this.confirmed - this.missing;
  }

}



// WEBPACK FOOTER //
// ./src/app/models/item/double-check.ts